import React, { useEffect, useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Input
} from "reactstrap";
import { postDataAPI } from "../../helpers/phpbackend_helper";

const AssignServersModal = ({ isOpen, toggle, card }) => {
  const [servers, setServers] = useState([]);
  const [selected, setSelected] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isOpen && card?.flash_id) {
      loadData();
    }
  }, [isOpen, card]);

  const loadData = async () => {
    setLoading(true);

    try {
      // 1️⃣ Load all servers
      const serverRes = await postDataAPI({
        serviceName: "server_data",
        op: "server_coaching_outlet_server_list",
        is_show_all: true,
        load: 0
      });

      // 2️⃣ Load assigned servers for flash card
      const assignedRes = await postDataAPI({
        serviceName: "server_data",
        op: "server_coaching_get_assign_server",
        flash_id: card.flash_id
      });

      if (serverRes.status === "ok") {
        setServers(serverRes.data.server_data || []);
      }

      if (assignedRes.status === "ok") {
        console.log(assignedRes.data);
        
        setSelected(assignedRes.data || []);
      }
    } finally {
      setLoading(false);
    }
  };

  const toggleSelect = (id) => {
    setSelected((prev) =>
      prev.includes(id)
        ? prev.filter((x) => x !== id)
        : [...prev, id]
    );
  };

  const handleSave = async () => {
    await postDataAPI({
      serviceName: "server_data",
      op: "create_update_flash_card_servers",
      flash_card_id: card.flash_id,
      server_id: selected
    });

    toggle();
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>
        Assign Servers to {card?.item_name}
      </ModalHeader>

      <ModalBody style={{ maxHeight: "60vh", overflowY: "auto" }}>
        {loading && <p className="text-muted">Loading...</p>}

        {!loading &&
          servers.map((server) => (
            <div
              key={server.server_id}
              className="d-flex align-items-center mb-2"
            >
              <Input
                type="checkbox"
                checked={selected.includes(Number(server.server_id))}
                onChange={() => toggleSelect(Number(server.server_id))}
                className="me-2"
              />
              <span>{server.name}</span>
            </div>
          ))}
      </ModalBody>

      <ModalFooter>
        <Button outline onClick={toggle}>
          Cancel
        </Button>
        <Button color="primary" onClick={handleSave}>
          Save
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default AssignServersModal;
